var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.bilevel = function(widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }

    widget.find('.loading-box').hide();
    widget.find('.chart').append($('<div class="djs-bilevel">'));

    //Widget expects every first column in a row to be the Parent and every second Column to be it's child
    function parseToJson(data) {

        var kendoConfig = metadata.KendoConfig;
        var nodeList = [];
        var totalSize = 0;

        data.forEach(function (item) {

            var size = 50;
            if (item[Object.keys(item)[2]] !== undefined) {
                size = item[Object.keys(item)[2]];
            }

            var node = {
                "Name": item[Object.keys(item)[1]],
                "Parent": item[Object.keys(item)[0]],
                "Size": size
            }
            totalSize += size;
            nodeList.push(node);
        });

        //Check if a root node was set by user. If not, attempt to find it.
        var root = "";
        if (kendoConfig.root === undefined) {
            root = getRootNode(nodeList);
        } else {
            root = kendoConfig.root;
        }

        var tree = {
            name: root,
            size: totalSize,
            children: getChildren(root, nodeList)
        };

        return tree;
    }

    //Expects one record in the result set to have no parents
    function getRootNode(nodeList) {
        var items = [];
        var parents = [];

        nodeList.forEach(function (i) {
            items.push(i.Name);
            parents.push(i.Parent);
        });

        for (var i = 0; i < parents.length; i++) {
            if (!items.includes(parents[i])) {
                return parents[i];
            }
        }
    }

    function getChildren(nodeName, nodeList) {
        var children = [];
        nodeList.forEach(function (i) {
            if (i.Parent === nodeName) {
                var child = {
                    name: i.Name,
                    size: i.Size,
                    children: getChildren(i.Name, nodeList)
                };
                children.push(child);
            }
        });
        return children;
    }
    function collapse(d) {
        if (d.children) {
            d._children = d.children;
            d._children.forEach(collapse);
            d.children = null;
        }
    }

    var width = MDB.Charts.calculateKendoChartMaxWidth(widget) / 100 * 140,
        height = width,
        radius = Math.min(width, height) / 2;

    var x = d3.scale.linear()
        .range([0, 2 * Math.PI]);

    var y = d3.scale.linear()
        .range([0, radius]);

    var color = d3.scale.category20c();

    var svg = d3.select(".djs-bilevel").append("svg")
        .attr("width", width)
        .attr("height", height + 50)
        .append("g")
        .attr("transform", "translate(" + (width / 2 + 80) + "," + (height / 2 + 30) + ")");

    var partition = d3.layout.partition()
        .value(function (d) {
            return d.size; 
        });

    var arc = d3.svg.arc()
        .startAngle(function (d) {
            return Math.max(0, Math.min(2 * Math.PI, x(d.x))); 
        })
        .endAngle(function (d) {
            return Math.max(0, Math.min(2 * Math.PI, x(d.x + d.dx))); 
        })
        .innerRadius(function (d) {
            return Math.max(0, y(d.y)); 
        })
        .outerRadius(function (d) {
            return Math.max(0, y(d.y + d.dy)); 
        });


    var root = parseToJson(data);

    var g = svg.selectAll("g")
        .data(partition.nodes(root))
        .enter().append("g");

    var path = g.append("path")
        .attr("d", arc)
        .style("fill", function (d) {
            return color((d.children ? d : d.parent).name); 
        })
        .on("click", click);

    var text;

    var kendoConfig = metadata.KendoConfig;
    if (kendoConfig.displayName) {
        text = g.append("text")
            .attr("transform", function(d) {
                return "rotate(" + computeTextRotation(d) + ")"; 
            })
            .attr("x", function(d) {
                return y(d.y); 
            })
            .attr("dx", "6") // margin
            .attr("dy", ".35em") // vertical-align
            .text(function(d) {
                return d.name; 
            });
    }

    function click(d) {
        // fade out all text elements
        if (kendoConfig.displayName !== undefined) {
            if (kendoConfig.displayName) {
                text.transition().attr("opacity", 0);
            }
        }

        path.transition()
            .duration(750)
            .attrTween("d", arcTween(d))
            .each("end", function (e, i) {
                // check if the animated element's data e lies within the visible angle span given in d
                if (e.x >= d.x && e.x < (d.x + d.dx)) {
                    // get a selection of the associated text element
                    var arcText = d3.select(this.parentNode).select("text");
                    // fade in the text element and recalculate positions
                    arcText.transition().duration(750)
                        .attr("opacity", 1)
                        .attr("transform", function () {
                            return "rotate(" + computeTextRotation(e) + ")" 
                        })
                        .attr("x", function (d) {
                            return y(d.y); 
                        });
                }
            });
    }

    d3.select(self.frameElement).style("height", height + "px");

    // Interpolate the scales!
    function arcTween(d) {
        var xd = d3.interpolate(x.domain(), [d.x, d.x + d.dx]),
            yd = d3.interpolate(y.domain(), [d.y, 1]),
            yr = d3.interpolate(y.range(), [d.y ? 20 : 0, radius]);
        return function (d, i) {
            return i
                ? function (t) {
                    return arc(d); 
                }
                : function (t) {
                    x.domain(xd(t)); y.domain(yd(t)).range(yr(t)); return arc(d); 
                };
        };
    }

    function computeTextRotation(d) {
        return (x(d.x + d.dx / 2) - Math.PI / 2) / Math.PI * 180;
    }
}